<template>
  <div class="attr-list">
    <el-button type="primary" @click="updateData">
      配置表格数据
    </el-button>
    <CommonAttr />
    <AddLTable
      ref="AddLTable"
      :dialog-visible="AddLTableVisi"
      @close="AddLTableVisi = false"
      @formOnSubmit="tableOnSubmit"
    />
  </div>
</template>

<script>
import CommonAttr from '../common/CommonAttr.vue'
import AddLTable from '../../components/AddLTable.vue'
import { mapState } from 'vuex'
export default {
  components: { CommonAttr, AddLTable },
  data() {
    return {
      AddLTableVisi: false
    }
  },
  computed: {
    ...mapState({
      canvasStyleData: (state) => state.compose.canvasStyleData
    }),
    curComponent() {
      return this.$store.state.compose.curComponent
    }
  },
  methods: {
    updateData() {
      this.$refs.AddLTable.setData(this.curComponent.tableData)
      this.AddLTableVisi = true
    },
    tableOnSubmit(tableData) {
      const trHeight = tableData.dataList[0].trHeight
      const tdWidth = tableData.dataList[0].children[0].tdWidth
      const style = this.curComponent.style
      style.height =
        (trHeight * tableData.rowNum * this.canvasStyleData.scale) / 100
      style.width =
        (tdWidth * tableData.colNum * this.canvasStyleData.scale) / 100
      this.$set(this.curComponent, 'tableData', tableData)
      this.$set(this.curComponent, 'style', style)
      console.log('this.curComponent', this.curComponent)
      console.log('this.canvasStyleData', this.canvasStyleData)
      console.log('tableData', tableData)
      // this.curComponent.tableData = tableData
      this.AddLTableVisi = false
    }
  }
}
</script>
